module.exports = __webpack_public_path__ + "img/瑞金纪念馆.2168fe1e.png";